import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import "./styles.css";
import ClassContainer from "../../templates/ClassContainer";
import SkillContainer from "../../templates/SkillContainer";
import InfoCharacter from "../../molecules/InfoCharacter";
import SkillInfoContainer from "../../templates/SkillInfoContainer";
import UpdateSkillPoints from "../../../services/UpdateSkillPoints";
import INIT_STATE from "../../../skill-data/InitStateSkills";
import SKILL_DATA from "../../../factories/SkillFactory";
import {
    points,
    index,
    pointsForThirdClass,
} from "../../../services/UpdateDisplayData";
import UpdateLevelInfo from "../../../services/UpdateLevelInfo";
import SignatureComponent from "../../molecules/SignatureComponent";
import generateBuildLink from "../../../services/ShareBuild";
import buildSharedData from "../../../factories/SharedBuildFactory";

export default React.memo(function Skill() {
    const params = useParams();
    const history = useHistory();
    const [actualClass, setActualClass] = useState("gladiador");
    const [skills, setSkills] = useState(SKILL_DATA[actualClass]);
    const [indexLevelInfo, setIndexLevelInfo] = useState(0);
    const [skillInfo, setSkillInfo] = useState(skills[indexLevelInfo]);
    const [skillsLevels, setSkillsLevels] = useState(INIT_STATE);
    const [charLevel, setCharLevel] = useState("71");
    const [thirdClassLevel, setThirdClassLevel] = useState("0");
    const [skillPoints, setSkillPoints] = useState(91);
    const [cooldown, setCooldown] = useState("0");
    const [indexSkllInfo, setIndexSkillInfo] = useState(0);
    const [levelSkillInfo, setLevelSkillInfo] = useState(INIT_STATE);

    const handleClick = (e) => {
        e.preventDefault();
        history.push("/attribute-calculator");
    };

    const handleShareBuild = (e) => {
        generateBuildLink(
            actualClass,
            charLevel,
            thirdClassLevel,
            cooldown,
            skillPoints,
            skillsLevels
        );

        alert("Link copiado!");
    };

    useEffect(() => {
        if (params.build) {
            const sharedBuild = buildSharedData(params.build);
            setActualClass(sharedBuild.actualClass);
            setSkills(SKILL_DATA[sharedBuild.actualClass]);
            setCharLevel(sharedBuild.charLevel);
            setThirdClassLevel(sharedBuild.thirdClassLevel);
            setCooldown(sharedBuild.cooldown);
            setSkillPoints(sharedBuild.skillPoints);
            setSkillsLevels(sharedBuild.skillsLevels);
        }
    }, [params]);

    const handleClickClassOrResetBuild = (e) => {
        if (e.target.alt) {
            setActualClass(e.target.alt);
            setSkills(SKILL_DATA[e.target.alt]);
            setSkillInfo(SKILL_DATA[e.target.alt][0]);
        } else {
            setSkillInfo(SKILL_DATA[actualClass][0]);
        }

        setIndexSkillInfo(0);
        setLevelSkillInfo(INIT_STATE);
        setIndexLevelInfo(0);
        setSkillsLevels(INIT_STATE);
        setCharLevel("71");
        setSkillPoints(91);
        setCooldown(0);
        setThirdClassLevel("0");
    };

    const handleClickDisplayInfoSkill = (e, indexClicked, skill) => {
        setSkillInfo(skill);
        setIndexSkillInfo(0);
        setLevelSkillInfo(skillsLevels);
        setIndexLevelInfo(index(skillsLevels, indexClicked));
        setIndexSkillInfo(indexClicked);
    };

    const handleClickUpdateSkill = (e, indexClicked, skill, updatePoints) => {
        const updateSkillsLevels = UpdateSkillPoints(
            updatePoints,
            skillsLevels,
            indexClicked,
            skillPoints,
            charLevel,
            skill
        );

        setIndexSkillInfo(indexClicked);
        setSkillsLevels(updateSkillsLevels);
        setLevelSkillInfo(updateSkillsLevels);
        setSkillInfo(skill);
        setIndexLevelInfo(index(updateSkillsLevels, indexClicked));
        setSkillPoints(
            points(skillPoints, updateSkillsLevels, skillsLevels, indexClicked)
        );
    };

    const handleClickInfoNavigator = (e, maxLevel, updatePoint) => {
        const actualInfoLevel = levelSkillInfo[indexSkllInfo];
        if (
            actualInfoLevel + updatePoint >= 0 &&
            actualInfoLevel + updatePoint <= maxLevel
        ) {
            const updatesList = UpdateLevelInfo(
                levelSkillInfo,
                updatePoint,
                indexSkllInfo
            );
            setLevelSkillInfo(updatesList);
            setIndexLevelInfo(index(updatesList, indexSkllInfo));
        }
    };

    const handleChangeCharLevel = (e) => {
        const value = parseInt(e.target.value);
        const parsedActualCharLevel = parseInt(charLevel);
        const ableToChangeLevel = (value < 99 && value > 0) || !value;
        setIndexLevelInfo(0);
        setSkillInfo(skills[0]);
        setSkillsLevels(INIT_STATE);

        if (value < 1 && parsedActualCharLevel !== 1) {
            setCharLevel("1");
            setSkillPoints(0);
        } else if (value >= 99 && parsedActualCharLevel !== 99) {
            setCharLevel("99");
            setSkillPoints(147);
        } else if (ableToChangeLevel) {
            setCharLevel(e.target.value);
            if (!value) setSkillPoints(0);
            else if (value > 50) {
                const diff = value - 50;
                setSkillPoints(49 + diff * 2);
            } else setSkillPoints(value - 1);
        }
    };

    const handleChangeThidClassLevel = (e) => {
        const value = parseInt(e.target.value);
        setIndexLevelInfo(0);
        setSkillInfo(skills[0]);
        setSkillsLevels(INIT_STATE);

        if (parseInt(charLevel) === 99) {
            if (value < 1) setThirdClassLevel("0");
            else if (value > 20) {
                setThirdClassLevel("20");
                setSkillPoints(207);
            } else {
                setThirdClassLevel(e.target.value);
                setSkillPoints(pointsForThirdClass(e.target.value));
            }
        }
    };

    const handleChangeCooldown = (e) => {
        const value = parseInt(e.target.value);
        if (value > 70) setCooldown("70");
        else if (value < 0) setCooldown(0);
        else setCooldown(e.target.value);
    };

    return (
        <div className="skill-container">
            <header>
                <h1>
                    {actualClass
                        .charAt(0)
                        .toUpperCase()
                        .concat(actualClass.slice(1))}
                </h1>

                <ClassContainer
                    imgId={"header"}
                    handleClickClassOrResetBuild={handleClickClassOrResetBuild}
                />
            </header>
            <div className="skill-content">
                <InfoCharacter
                    charLevel={charLevel}
                    thirdClassLevel={thirdClassLevel}
                    skillPoints={skillPoints}
                    cooldown={cooldown}
                    handleChangeThidClassLevel={handleChangeThidClassLevel}
                    handleChangeCharLevel={handleChangeCharLevel}
                    handleChangeCooldown={handleChangeCooldown}
                    handleReset={handleClickClassOrResetBuild}
                    handleShare={handleShareBuild}
                    handleClick={handleClick}
                />
                <div className="info-container">
                    <SkillContainer
                        skills={skills}
                        skillLevel={skillsLevels}
                        handleClickDisplayInfoSkill={
                            handleClickDisplayInfoSkill
                        }
                        handleClickUpdateSkill={handleClickUpdateSkill}
                    />
                    <SkillInfoContainer
                        skill={skillInfo}
                        index={indexLevelInfo}
                        cooldown={cooldown === 0 ? 0 : cooldown / 100}
                        skillLevel={levelSkillInfo[indexSkllInfo]}
                        handleClickInfoNavigator={handleClickInfoNavigator}
                    />
                </div>
            </div>
            <SignatureComponent />
        </div>
    );
});
